export const NO_CLASSIFICATION_OPTION_ID = 'data-classification.no-classification-option';
